import { useMemo, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import '../../assets/styles/data_table/DataTable.css'

ModuleRegistry.registerModules([AllCommunityModule]);

export default function DataTable(props) {

    const gridRef = useRef()

    const defaultColDef = useMemo(() => ({
        filter: false,
        flex: 2,
        resizable: true,
        suppressHeaderMenuButton: true,
        // width: 200
        cellStyle: {
            fontSize: '12px',
            fontFamily: 'Lexend Deca'
        }
    }), [])

    // const calculateTotal = () => {
    //     if (props.rowData && props.rowData.length > 0) {
    //         const total = props.rowData.reduce((acc, row) => acc + parseInt(row.price), 0);
    //         return { make: 'Total', model: '', price: total.toString() };
    //     }
    //     return {};
    // };

    // const pinnedBottomRowData = useMemo(() => {
    //     const totalRow = calculateTotal();
    //     return totalRow ? [totalRow] : [];
    // }, [props.rowData]);

    return (
        <>
            <div className="ag-theme-alpine" style={{ height: props?.height || '70vh', width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    loading={props.loading}
                    rowData={props.rowData}
                    columnDefs={props.columnDefs}
                    defaultColDef={defaultColDef}
                    headerHeight={35}
                    rowHeight={35}
                    // enableRtl={localStorage.getItem('lang_key') === 'ar' ? true : false}
                    // pinnedBottomRowData={pinnedBottomRowData}
                    overlayLoadingTemplate={
                        '<div aria-live="polite" aria-atomic="true" style="height:100px; width:100px; background: url(https://ag-grid.com/images/ag-grid-loading-spinner.svg) center / contain no-repeat; margin: 0 auto;" aria-label="loading"></div>'
                    }
                    scrollbarWidth={5}
                    enableCellTextSelection={false}
                />
            </div >
        </>
    )
}